<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <AifluentContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import AifluentContent from "~~/codepresso-renewal/content/AifluentContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "AI Fluent: AI 활용 역량 진단 | 코드프레소",
  meta: [
    { name: "description", content: "문제 정의, 프롬프트 설계, 워크플로·Agent 활용, 결과 검증까지. 실제 업무 속 AI 활용 역량을 진단합니다." },
    { name: "title", content: "AI Fluent: AI 활용 역량 진단 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "AI Fluent: AI 활용 역량 진단 | 코드프레소" },
    { property: "og:description", content: "문제 정의, 프롬프트 설계, 워크플로·Agent 활용, 결과 검증까지. 실제 업무 속 AI 활용 역량을 진단합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/aifluent.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
